export default {
  tag: 'Test',
  tag_tooltip: 'Testrestaurant: voll funktionsfähig, wird nie abgerechnet.',
  card: {
    title: 'Testrestaurant',
    description:
      'Markieren Sie ein Restaurant als Testrestaurant, um Druck, E-Mails, Bestellungen und Integrationen im Live-Betrieb zu testen. Es funktioniert wie jedes andere Restaurant und wird nie abgerechnet. Kunden-E-Mails und -SMS zu seinen Bestellungen beginnen mit [TEST].',
    payments_note:
      'Zahlungen im Testrestaurant sind echt und werden wie alle anderen ausgezahlt. Erstatten Sie Testbestellungen selbst. Wir werden benachrichtigt, wenn sein Monatsumsatz über einen Test hinausgeht.',
    designated_on: 'Als Test markiert am {{date}}',
    open_shop: 'Shop öffnen',
    remove: 'Test-Markierung entfernen',
    select_placeholder: 'Restaurant auswählen',
    mark: 'Als Testrestaurant markieren',
    no_restaurants: 'Sie haben noch kein Restaurant, das Sie markieren können.',
    load_error: 'Ihr Testrestaurant konnte nicht geladen werden.',
  },
  remove_confirm: {
    title: 'Test-Markierung von {{name}} entfernen?',
    description_live:
      'Die Abrechnung für dieses Restaurant wird fortgesetzt, und es geht sofort offline. Starten Sie es über Bestell Einstellungen → Bestellmethoden → Live orders neu – dort wählen Sie seinen Plan.',
    description_stays_live:
      'Dieses Restaurant bleibt live und wird ab jetzt wieder wie Ihre anderen Restaurants behandelt.',
    description_offline:
      'Die Abrechnung für dieses Restaurant beginnt, sobald es live geht. Seinen Plan wählen Sie beim Start.',
    confirm: 'Test-Markierung entfernen',
  },
  toasts: {
    designated: '{{name}} ist jetzt Ihr Testrestaurant und wird nicht abgerechnet.',
    designate_error: 'Das Restaurant konnte nicht als Test markiert werden. Bitte versuchen Sie es erneut.',
    removed: '{{name}} ist nicht mehr Ihr Testrestaurant.',
    removed_offline: '{{name}} ist nicht mehr Ihr Testrestaurant und jetzt offline.',
    remove_error: 'Die Test-Markierung konnte nicht entfernt werden. Bitte versuchen Sie es erneut.',
  },
};
